import type { AddressObject, InputMaybe, LangCode } from "@/lib/gql/__generated__/graphql";

import type { ForAutoGenerator } from "@/components/features/_model/types/auto-generator-for-view-model";
import { useFormAddressModel } from "@/components/features/items/edit/_shared/ui/components/main/questions/address/address/hooks/use-address";

import type { HotelSettingsHotelInfoI18nFormModelOnSetViewModelType } from "../..";
import type { HotelSettingsHotelInfoI18nFormModel } from "../../../../type";

type Props = {
	viewModel: HotelSettingsHotelInfoI18nFormModel["ViewModel"];
	onSetViewModel: HotelSettingsHotelInfoI18nFormModelOnSetViewModelType;
	lang: LangCode;
};

export type HotelSettingsHotelInfoI18nFormModelAddressMethodsType = {
	addressMethods: {
		isEdited: boolean | undefined;
		hasError: boolean;
		address: ForAutoGenerator<InputMaybe<AddressObject> | undefined, "">;
		onSetPref: (e: string) => void;
		onSetCity: (e: string) => void;
		onSetTown: (e: string) => void;
		onSetPostalCode: (e: string) => Promise<void>;
	};
};

export const useHotelInfoI18nAddress = ({
	viewModel,
	onSetViewModel,
	lang,
}: Props): HotelSettingsHotelInfoI18nFormModelAddressMethodsType => {
	return {
		addressMethods: {
			...useFormAddressModel({ address: viewModel.address, lang, onSetViewModel }),
		},
	};
};
